import {
  ControlledCheckbox,
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { FormFieldsWrapper } from 'components/shared/AdminSettings/FormFieldsWrapper';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { useHandleValidSettings } from './hooks/useHandleValidSettings';
import { WarningTooltip } from 'components/shared/WarningTooltip';

const CONNECTION_OPTIONS: Option[] = [
  { label: 'TLS', value: 'TLS' },
  { label: 'SSL', value: 'SSL' }
];

export const MailFields = () => {
  const { t: tMailSMS } = useTranslation('common', { keyPrefix: 'mailAndSMS' });
  const { t } = useTranslation('common', {
    keyPrefix: 'mailAndSMS.mailSection.form'
  });
  const methods = useFormContext();
  const { control } = methods;
  const isValid = useHandleValidSettings(methods, 'mail.valid', 'mail.active');

  return (
    <>
      <FormFieldsWrapper noPadding>
        <WarningTooltip
          title={tMailSMS('incompleteMessage')}
          isVisible={isValid === false}
        >
          <ControlledCheckbox
            disabled={isValid === false}
            control={control}
            name="mail.active"
            label={t('active')}
          />
        </WarningTooltip>
        <ControlledTextField
          control={control}
          name="mail.mail_smtp_host"
          label={t('address')}
        />
        <ControlledSelect
          control={control}
          options={CONNECTION_OPTIONS}
          name="mail.mail_smtp_conn_type"
          label={t('authentication')}
        />
        <ControlledTextField
          control={control}
          name="mail.mail_smtp_username"
          label={t('username')}
        />
        <ControlledTextField
          type="password"
          control={control}
          name="mail.mail_smtp_password"
          label={t('password')}
        />
        <ControlledTextField
          type="number"
          control={control}
          name="mail.mail_smtp_port"
          label={t('port')}
        />
        <ControlledTextField
          type="number"
          control={control}
          name="mail.mail_smtp_timeout"
          label={t('timeout')}
        />
        <ControlledTextField
          control={control}
          name="mail.mail_smtp_mime_charset"
          label={t('characterSet')}
        />
        <ControlledTextField
          control={control}
          name="mail.mail_smtp_sender_address"
          label={t('answerTo')}
        />
      </FormFieldsWrapper>
    </>
  );
};
